import type { FC } from 'react';
import Box from '@mui/material/Box';

const SlashScreen: FC = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}
  >
    <img alt="animate-logo" width={100} height={100} src="/logo.gif" />
  </Box>
);

export default SlashScreen;
